class Callbacks {
  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      if (_.has(values, 'name'))
        _.merge(values, { name: { contains: values?.name } })

      return {
        generic: true,
        ...values
      }
    }
  }

  static filterToFormHandler() {
    return function filterToForm(filter) {
      return { accuracy: 'high', ...filter }
    }
  }
}

export default Callbacks
